import { FC, useMemo } from "react";

import { usePageContext } from "@ryde/redux";

import {
  DriverExpand,
  GenericExpand,
  PassengerExpand,
  StationExpand,
} from "./parts";

export const ExpandFloatingMenuFlow: FC = () => {
  const { entity } = usePageContext();

  const entityExpandFlow = useMemo(() => {
    switch (entity) {
      case "passenger":
        return <PassengerExpand />;
      case "driver":
        return <DriverExpand />;
      case "station":
        return <StationExpand />;
      default:
        return null;
    }
  }, [entity]);

  return (
    <>
      {entityExpandFlow}
      <GenericExpand entity={entity} />
    </>
  );
};
